export const hongbao = {
    hb: "紅包",
    dps: "大派送",
    xdhb: "限定紅包，千萬福利等你來搶",
    fxhb: "分享紅包，贏得更多紅包獎勵",
    khb: "開啟紅包",
    kqz: "開啟中...",
    ylq: "已領取",
    hdwks: "活動未開始",
    hdjxz: "活動進行中",
    hdyjs: "活動已結束",
    hddjs: "活動倒計時",
    hdsj: "活動時間",
    zwhd: "暫無活動",
    hblsjlxq: "我的紅包歷史獎勵詳情",
    jxz: "進行中",
    ygq: "已過期",
    dks: "待開始",
    zwjl: "暫無獎勵",
    wnmztj: "您未滿足活動條件",
    wxts: "溫馨提示",
    yhwcrz: "使用者已完成KYC認證和手機號碼綁定",
    yhwcjy: "用戶完成現貨交易≥100 USDT或合約交易（不含槓桿）≥100 USDT或期權交易≥100 USDT或GameFi交易≥100 USDT其中一條",
    djzh: "風控或限制提幣帳戶不能參與活動",
    hdhbjl: "獲得紅包獎勵",
    sqbj: "手氣不佳",
    dkapp: "打開APP",
    smewm: "掃描二維碼",
    wchdtj: "完成活動條件，領取紅包",
    fxhd: "分享活動，獲得更多紅包",
    jdcz: "簡單操作，賺取收益",
    hdhb: "活動紅包",
    wcjye: "完成{type}交易額{text}≥{amount}USDT",
    yhwfhtj: "紅包上線前{time}內，用戶無符合條件交易",
    hbsxq: "紅包上線前{time}{day}內，使用者{text}",
    bhgg: "不含槓桿",
    h: " 或 ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/tw.js